export default function TS_Quiz() {
  return (
    <div>
      <h1>TS Quiz</h1>
      <p>This is the TS Quiz page.</p>
    </div>
  );
}